import React, { createContext, useState } from 'react';

export const BookingContext = createContext();

const BookingProvider = ({ children }) => {
  const [bookings, setBookings] = useState([]);

  const addBooking = (b) => setBookings((s) => [...s, b]);
  const removeBooking = (index) => setBookings((s) => s.filter((_, i) => i !== index));
  const updateBooking = (id, patch) => setBookings((s) => s.map((b) => (b.id === id ? { ...b, ...patch } : b)));
  const clearBookings = () => setBookings([]);

  const value = {
    bookings,
    count: bookings.length,
    addBooking,
    updateBooking,
    removeBooking,
    clearBookings,
  };

  return <BookingContext.Provider value={value}>{children}</BookingContext.Provider>;
};

export default BookingProvider;
